export default __webpack_public_path__ + "static/media/kcb-bank.c2d277fe.jpg";